module.exports = __webpack_public_path__ + "static/the-hunger-games-d443e5574f3022955e9a24f1134dc6db.jpg";